
function getLanguageIcon(lang)
{
    return '/assets/languages/' + lang.split('-')[0] + '.png';
}
export default getLanguageIcon;
